import { render, staticRenderFns } from "./bancos_screen.vue?vue&type=template&id=537efa76&scoped=true"
import script from "./bancos_screen.vue?vue&type=script&lang=js"
export * from "./bancos_screen.vue?vue&type=script&lang=js"
import style0 from "./bancos_screen.vue?vue&type=style&index=0&id=537efa76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537efa76",
  null
  
)

export default component.exports